import axios from 'axios';
import { auth } from './firebase';

const getBaseUrl = () => {
  // Check if a custom API URL is provided via environment variable
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Fallback to NODE_ENV based logic
  const env = process.env.NODE_ENV;
  switch (env) {
    case 'development':
      return 'http://localhost:8000';
    case 'test':
      return 'http://127.0.0.1:5001/gamester-app-ee53b/us-central1';
    default:
      return 'https://europe-west3-gamester-app-ee53b.cloudfunctions.net/api';
  }
};

export const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to add the auth token
api.interceptors.request.use(
  async config => {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// Add a response interceptor to handle auth errors
api.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      // Clear invalid token
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Sign out from Firebase
      await auth.signOut();

      // Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
